import { createSelector } from 'reselect';

const isImpersonating = auth => !!auth?.impersonation?.token?.hash;

export default createSelector(state => state.auth, isImpersonating);
